export const UnselectedCheckboxIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="3"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 3 9)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="3"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 3 11)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="3"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 3 13)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="3"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 3 15)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="3"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 3 17)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="19"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 19 15)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="19"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 19 17)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="7"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 7 21)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="9"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 9 21)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="13"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 13 21)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="15"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 15 21)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="11"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 11 21)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="5"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 5 6.94678)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="5"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 5 18.9468)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="7"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 7 5)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="9"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 9 5)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="17"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 17 6.94678)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="13"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 13 5)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="15"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 15 5)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="11"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 11 5)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="17"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 17 18.9468)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="19"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 19 9)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="19"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 19 11)"
      fill="white"
      fillOpacity="0.4"
    />
    <rect
      x="19"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 19 13)"
      fill="white"
      fillOpacity="0.4"
    />
  </svg>
);

export const SelectedCheckboxIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="3"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 3 9)"
      fill="white"
    />
    <rect
      x="3"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 3 11)"
      fill="white"
    />
    <rect
      x="3"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 3 13)"
      fill="white"
    />
    <rect
      x="3"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 3 15)"
      fill="white"
    />
    <rect
      x="3"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 3 17)"
      fill="white"
    />
    <rect
      x="19"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 19 15)"
      fill="white"
    />
    <rect
      x="19"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 19 17)"
      fill="white"
    />
    <rect
      x="7"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 7 21)"
      fill="white"
    />
    <rect
      x="9"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 9 21)"
      fill="white"
    />
    <rect
      x="13"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 13 21)"
      fill="white"
    />
    <rect
      x="15"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 15 21)"
      fill="white"
    />
    <rect
      x="11"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 11 21)"
      fill="white"
    />
    <rect
      x="5"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 5 6.94678)"
      fill="white"
    />
    <rect
      x="9"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 9 11)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 9 13)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 9 15)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 11 11)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 11 13)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 11 15)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 13 13)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 13 15)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 13 11)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 5 18.9468)"
      fill="white"
    />
    <rect
      x="7"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 7 5)"
      fill="white"
    />
    <rect
      x="9"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 9 5)"
      fill="white"
    />
    <rect
      x="17"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 17 6.94678)"
      fill="white"
    />
    <rect
      x="13"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 13 5)"
      fill="white"
    />
    <rect
      x="15"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 15 5)"
      fill="white"
    />
    <rect
      x="11"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 11 5)"
      fill="white"
    />
    <rect
      x="17"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 17 18.9468)"
      fill="white"
    />
    <rect
      x="19"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 19 9)"
      fill="white"
    />
    <rect
      x="19"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 19 11)"
      fill="white"
    />
    <rect
      x="19"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 19 13)"
      fill="white"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="11" y="3" width="2" height="2" fill="white" />
    <rect
      x="13"
      y="19"
      width="2"
      height="2"
      transform="rotate(-180 13 19)"
      fill="white"
    />
    <rect x="9" y="3" width="2" height="2" fill="white" />
    <rect x="5" y="7" width="2" height="2" fill="white" />
    <rect x="5" y="5" width="2" height="2" fill="white" />
    <rect x="7" y="5" width="2" height="2" fill="white" />
    <rect x="3" y="9" width="2" height="2" fill="white" />
    <rect
      x="17"
      y="15"
      width="2"
      height="2"
      transform="rotate(-180 17 15)"
      fill="white"
    />
    <rect
      x="17"
      y="17"
      width="2"
      height="2"
      transform="rotate(-180 17 17)"
      fill="white"
    />
    <rect
      x="19"
      y="19"
      width="2"
      height="2"
      transform="rotate(-180 19 19)"
      fill="white"
    />
    <rect
      x="21"
      y="21"
      width="2"
      height="2"
      transform="rotate(-180 21 21)"
      fill="white"
    />
    <rect
      x="15"
      y="17"
      width="2"
      height="2"
      transform="rotate(-180 15 17)"
      fill="white"
    />
    <rect x="3" y="11" width="2" height="2" fill="white" />
    <rect x="13" y="5" width="2" height="2" fill="white" />
    <rect x="15" y="5" width="2" height="2" fill="white" />
    <rect x="15" y="7" width="2" height="2" fill="white" />
    <rect
      x="9"
      y="17"
      width="2"
      height="2"
      transform="rotate(-180 9 17)"
      fill="white"
    />
    <rect
      x="7"
      y="17"
      width="2"
      height="2"
      transform="rotate(-180 7 17)"
      fill="white"
    />
    <rect
      x="7"
      y="15"
      width="2"
      height="2"
      transform="rotate(-180 7 15)"
      fill="white"
    />
    <rect
      x="11"
      y="19"
      width="2"
      height="2"
      transform="rotate(-180 11 19)"
      fill="white"
    />
    <rect x="17" y="9" width="2" height="2" fill="white" />
    <rect x="17" y="11" width="2" height="2" fill="white" />
  </svg>
);

export const BackButtonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="11"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 11 11)"
      fill="black"
    />
    <rect
      x="13"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 13 11)"
      fill="black"
    />
    <rect
      x="15"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 15 11)"
      fill="black"
    />
    <rect
      x="17"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 17 11)"
      fill="black"
    />
    <rect
      x="19"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 19 11)"
      fill="black"
    />
    <rect
      x="11"
      y="7"
      width="2"
      height="2"
      transform="rotate(90 11 7)"
      fill="black"
    />
    <rect
      x="13"
      y="5"
      width="2"
      height="2"
      transform="rotate(90 13 5)"
      fill="black"
    />
    <rect
      x="9"
      y="9"
      width="2"
      height="2"
      transform="rotate(90 9 9)"
      fill="black"
    />
    <rect
      x="7"
      y="11"
      width="2"
      height="2"
      transform="rotate(90 7 11)"
      fill="black"
    />
    <rect
      x="9"
      y="13"
      width="2"
      height="2"
      transform="rotate(90 9 13)"
      fill="black"
    />
    <rect
      x="11"
      y="15"
      width="2"
      height="2"
      transform="rotate(90 11 15)"
      fill="black"
    />
    <rect
      x="13"
      y="17"
      width="2"
      height="2"
      transform="rotate(90 13 17)"
      fill="black"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect
      x="11.3689"
      y="11.3334"
      width="1.33333"
      height="1.33333"
      fill="white"
    />
    <rect x="6.03558" y="6" width="1.33333" height="1.33333" fill="white" />
    <rect x="10.0356" y="10" width="1.33333" height="1.33333" fill="white" />
    <rect
      x="4.70221"
      y="4.66663"
      width="1.33333"
      height="1.33333"
      fill="white"
    />
    <rect
      x="8.70221"
      y="8.66663"
      width="1.33333"
      height="1.33333"
      fill="white"
    />
    <rect
      x="3.3689"
      y="3.33337"
      width="1.33333"
      height="1.33333"
      fill="white"
    />
    <rect
      x="7.3689"
      y="7.33337"
      width="1.33333"
      height="1.33333"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 11.3689 4.66663)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 6.03558 10)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 10.0356 6)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 4.70221 11.3334)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 8.70221 7.33337)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 3.3689 12.6666)"
      fill="white"
    />
    <rect
      width="1.33333"
      height="1.33333"
      transform="matrix(1 -4.37114e-07 -4.37114e-07 -1 7.3689 8.66663)"
      fill="white"
    />
  </svg>
);

export const SelectedItemIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="3"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 3 9)"
      fill="#2E2E2E"
    />
    <rect
      x="3"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 3 11)"
      fill="#2E2E2E"
    />
    <rect
      x="3"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 3 13)"
      fill="#2E2E2E"
    />
    <rect
      x="3"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 3 15)"
      fill="#2E2E2E"
    />
    <rect
      x="3"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 3 17)"
      fill="#2E2E2E"
    />
    <rect
      x="19"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 19 15)"
      fill="#2E2E2E"
    />
    <rect
      x="19"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 19 17)"
      fill="#2E2E2E"
    />
    <rect
      x="7"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 7 21)"
      fill="#2E2E2E"
    />
    <rect
      x="9"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 9 21)"
      fill="#2E2E2E"
    />
    <rect
      x="13"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 13 21)"
      fill="#2E2E2E"
    />
    <rect
      x="15"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 15 21)"
      fill="#2E2E2E"
    />
    <rect
      x="11"
      y="21"
      width="2"
      height="2"
      transform="rotate(-90 11 21)"
      fill="#2E2E2E"
    />
    <rect
      x="5"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 5 6.94678)"
      fill="#2E2E2E"
    />
    <rect
      x="9"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 9 11)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 7 11)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 9 9)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 7 9)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="7"
      width="2"
      height="2"
      transform="rotate(-90 9 7)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="7"
      width="2"
      height="2"
      transform="rotate(-90 7 7)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 9 13)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 7 13)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 9 15)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 7 15)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 9 17)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 7 17)"
      fill="#02FFFF"
    />
    <rect
      x="9"
      y="19"
      width="2"
      height="2"
      transform="rotate(-90 9 19)"
      fill="#02FFFF"
    />
    <rect
      x="7"
      y="19"
      width="2"
      height="2"
      transform="rotate(-90 7 19)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 11 11)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 11 9)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="7"
      width="2"
      height="2"
      transform="rotate(-90 11 7)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 11 13)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 11 15)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 11 17)"
      fill="#02FFFF"
    />
    <rect
      x="11"
      y="19"
      width="2"
      height="2"
      transform="rotate(-90 11 19)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 13 13)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 15 13)"
      fill="#02FFFF"
    />
    <rect
      x="17"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 17 13)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 5 13)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 13 15)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 15 15)"
      fill="#02FFFF"
    />
    <rect
      x="17"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 17 15)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="15"
      width="2"
      height="2"
      transform="rotate(-90 5 15)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 13 17)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 15 17)"
      fill="#02FFFF"
    />
    <rect
      x="17"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 17 17)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 5 17)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="19"
      width="2"
      height="2"
      transform="rotate(-90 13 19)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="19"
      width="2"
      height="2"
      transform="rotate(-90 15 19)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 13 11)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 15 11)"
      fill="#02FFFF"
    />
    <rect
      x="17"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 17 11)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 5 11)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 13 9)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 15 9)"
      fill="#02FFFF"
    />
    <rect
      x="17"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 17 9)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 5 9)"
      fill="#02FFFF"
    />
    <rect
      x="13"
      y="7"
      width="2"
      height="2"
      transform="rotate(-90 13 7)"
      fill="#02FFFF"
    />
    <rect
      x="15"
      y="7"
      width="2"
      height="2"
      transform="rotate(-90 15 7)"
      fill="#02FFFF"
    />
    <rect
      x="5"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 5 18.9468)"
      fill="#2E2E2E"
    />
    <rect
      x="7"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 7 5)"
      fill="#2E2E2E"
    />
    <rect
      x="9"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 9 5)"
      fill="#2E2E2E"
    />
    <rect
      x="17"
      y="6.94678"
      width="2"
      height="2"
      transform="rotate(-90 17 6.94678)"
      fill="#2E2E2E"
    />
    <rect
      x="13"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 13 5)"
      fill="#2E2E2E"
    />
    <rect
      x="15"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 15 5)"
      fill="#2E2E2E"
    />
    <rect
      x="11"
      y="5"
      width="2"
      height="2"
      transform="rotate(-90 11 5)"
      fill="#2E2E2E"
    />
    <rect
      x="17"
      y="18.9468"
      width="2"
      height="2"
      transform="rotate(-90 17 18.9468)"
      fill="#2E2E2E"
    />
    <rect
      x="19"
      y="9"
      width="2"
      height="2"
      transform="rotate(-90 19 9)"
      fill="#2E2E2E"
    />
    <rect
      x="19"
      y="11"
      width="2"
      height="2"
      transform="rotate(-90 19 11)"
      fill="#2E2E2E"
    />
    <rect
      x="19"
      y="13"
      width="2"
      height="2"
      transform="rotate(-90 19 13)"
      fill="#2E2E2E"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect
      x="12.8333"
      y="15.1666"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect
      x="12.8333"
      y="12.8334"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect x="12.8333" y="10.5" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="12.8333"
      y="8.16663"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect
      x="12.8333"
      y="5.83337"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect
      x="8.16666"
      y="15.1666"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect
      x="5.83334"
      y="12.8334"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect x="10.5" y="17.5" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="12.8333"
      y="19.8334"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
    <rect x="15.1667" y="17.5" width="2.33333" height="2.33333" fill="white" />
    <rect x="17.5" y="15.1666" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="19.8333"
      y="12.8334"
      width="2.33333"
      height="2.33333"
      fill="white"
    />
  </svg>
);

export const DownloadIconAlt = ({ fill = 'black' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect
      x="9.16669"
      y="8.33337"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="9.16669"
      y="6.66663"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect x="9.16669" y="5" width="1.66667" height="1.66667" fill={fill} />
    <rect
      x="9.16669"
      y="3.33337"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="5.83331"
      y="8.33337"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect x="7.5" y="10" width="1.66667" height="1.66667" fill={fill} />
    <rect
      x="9.16669"
      y="11.6666"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="9.16669"
      y="14.9556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="10.8333"
      y="14.9556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect x="12.5" y="14.9556" width="1.66667" height="1.66667" fill={fill} />
    <rect
      x="14.1667"
      y="14.9556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="14.1667"
      y="13.2889"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect x="7.5" y="14.9556" width="1.66667" height="1.66667" fill={fill} />
    <rect
      x="5.83331"
      y="14.9556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="4.16669"
      y="14.9556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="4.16669"
      y="13.2889"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect x="10.8333" y="10" width="1.66667" height="1.66667" fill={fill} />
    <rect x="12.5" y="8.33337" width="1.66667" height="1.66667" fill={fill} />
  </svg>
);

export const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="19"
      y="13.9467"
      width="2"
      height="2"
      transform="rotate(-180 19 13.9467)"
      fill="#FF0000"
    />
    <rect
      x="21"
      y="15.9467"
      width="2"
      height="2"
      transform="rotate(-180 21 15.9467)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="16.9467"
      width="2"
      height="2"
      transform="rotate(-180 13 16.9467)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="10.9467"
      width="2"
      height="2"
      transform="rotate(-180 13 10.9467)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="12.9467"
      width="2"
      height="2"
      transform="rotate(-180 13 12.9467)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="8.94666"
      width="2"
      height="2"
      transform="rotate(-180 13 8.94666)"
      fill="#FF0000"
    />
    <rect
      x="5"
      y="17.9467"
      width="2"
      height="2"
      transform="rotate(-180 5 17.9467)"
      fill="#FF0000"
    />
    <rect
      x="5"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 5 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 7 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="9"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 9 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="11"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 11 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 13 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="15"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 15 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="17"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 17 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="19"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 19 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="21"
      y="19.9467"
      width="2"
      height="2"
      transform="rotate(-180 21 19.9467)"
      fill="#FF0000"
    />
    <rect
      x="21"
      y="17.9467"
      width="2"
      height="2"
      transform="rotate(-180 21 17.9467)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="13.9467"
      width="2"
      height="2"
      transform="rotate(-180 7 13.9467)"
      fill="#FF0000"
    />
    <rect
      x="5"
      y="15.9467"
      width="2"
      height="2"
      transform="rotate(-180 5 15.9467)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="11.9467"
      width="2"
      height="2"
      transform="rotate(-180 7 11.9467)"
      fill="#FF0000"
    />
    <rect
      x="19"
      y="11.9467"
      width="2"
      height="2"
      transform="rotate(-180 19 11.9467)"
      fill="#FF0000"
    />
    <rect
      x="9"
      y="9.94666"
      width="2"
      height="2"
      transform="rotate(-180 9 9.94666)"
      fill="#FF0000"
    />
    <rect
      x="9"
      y="7.94666"
      width="2"
      height="2"
      transform="rotate(-180 9 7.94666)"
      fill="#FF0000"
    />
    <rect
      x="11"
      y="5.94666"
      width="2"
      height="2"
      transform="rotate(-180 11 5.94666)"
      fill="#FF0000"
    />
    <rect
      x="15"
      y="5.94666"
      width="2"
      height="2"
      transform="rotate(-180 15 5.94666)"
      fill="#FF0000"
    />
    <rect
      x="13"
      y="3.94666"
      width="2"
      height="2"
      transform="rotate(-180 13 3.94666)"
      fill="#FF0000"
    />
    <rect
      x="17"
      y="9.94666"
      width="2"
      height="2"
      transform="rotate(-180 17 9.94666)"
      fill="#FF0000"
    />
    <rect
      x="17"
      y="7.94666"
      width="2"
      height="2"
      transform="rotate(-180 17 7.94666)"
      fill="#FF0000"
    />
  </svg>
);

export const SendIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect
      x="10.8333"
      y="9.16669"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 9.16669)"
      fill="#767676"
    />
    <rect
      x="10.8333"
      y="10.8333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 10.8333)"
      fill="#767676"
    />
    <rect
      x="10.8333"
      y="12.5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 12.5)"
      fill="#767676"
    />
    <rect
      x="10.8333"
      y="14.1667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 14.1667)"
      fill="#767676"
    />
    <rect
      x="10.8333"
      y="15.8333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 15.8333)"
      fill="#767676"
    />
    <rect
      x="14.1667"
      y="9.16669"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 14.1667 9.16669)"
      fill="#767676"
    />
    <rect
      x="15.8333"
      y="10.8333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 15.8333 10.8333)"
      fill="#767676"
    />
    <rect
      x="12.5"
      y="7.5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 12.5 7.5)"
      fill="#767676"
    />
    <rect
      x="10.8333"
      y="5.83331"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8333 5.83331)"
      fill="#767676"
    />
    <rect
      x="9.16669"
      y="7.5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 9.16669 7.5)"
      fill="#767676"
    />
    <rect
      x="7.5"
      y="9.16669"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 7.5 9.16669)"
      fill="#767676"
    />
    <rect
      x="5.83331"
      y="10.8333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 5.83331 10.8333)"
      fill="#767676"
    />
  </svg>
);

export const AttachmentIcon = ({ fill = 'white' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect x="7.5" y="9.12219" width="1.66667" height="1.66667" fill={fill} />
    <rect
      x="5.8335"
      y="9.12219"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="4.1665"
      y="9.12219"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="14.1665"
      y="10.7889"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 14.1665 10.7889)"
      fill={fill}
    />
    <rect
      x="15.8335"
      y="10.7889"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 15.8335 10.7889)"
      fill={fill}
    />
    <rect
      x="12.5"
      y="10.7889"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 12.5 10.7889)"
      fill={fill}
    />
    <rect
      x="10.8335"
      y="5.78888"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8335 5.78888)"
      fill={fill}
    />
    <rect
      x="10.8335"
      y="7.45557"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8335 7.45557)"
      fill={fill}
    />
    <rect
      x="10.8335"
      y="9.12219"
      width="1.66667"
      height="1.66667"
      transform="rotate(-180 10.8335 9.12219)"
      fill={fill}
    />
    <rect
      x="9.1665"
      y="9.12219"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="9.1665"
      y="10.7889"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="9.1665"
      y="12.4556"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
    <rect
      x="9.1665"
      y="14.1222"
      width="1.66667"
      height="1.66667"
      fill={fill}
    />
  </svg>
);
export const RiffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <rect
      x="1.75"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 2.33325)"
      fill="black"
    />
    <rect
      x="1.75"
      y="3.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 3.5)"
      fill="black"
    />
    <rect
      x="1.75"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 4.66675)"
      fill="black"
    />
    <rect
      x="1.75"
      y="5.83325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 5.83325)"
      fill="black"
    />
    <rect
      x="1.75"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 7)"
      fill="black"
    />
    <rect
      x="1.75"
      y="8.16675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 8.16675)"
      fill="black"
    />
    <rect
      x="1.75"
      y="9.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 9.33325)"
      fill="black"
    />
    <rect
      x="1.75"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 10.5)"
      fill="black"
    />
    <rect
      x="1.75"
      y="11.6667"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 11.6667)"
      fill="black"
    />
    <rect
      x="1.75"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 1.75 12.8333)"
      fill="black"
    />
    <rect
      x="2.9165"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 2.9165 12.8333)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 12.8333)"
      fill="black"
    />
    <rect
      x="5.25"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 5.25 12.8333)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 12.8333)"
      fill="black"
    />
    <rect
      x="7.5835"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 7.5835 12.8333)"
      fill="black"
    />
    <rect
      x="8.75"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 12.8333)"
      fill="black"
    />
    <rect
      x="9.9165"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 9.9165 12.8333)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="12.8333"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 12.8333)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="11.6667"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 11.6667)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 10.5)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="9.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 9.33325)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="8.16675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 8.16675)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 7)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="5.83325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 5.83325)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 4.66675)"
      fill="black"
    />
    <rect
      x="9.9165"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 9.9165 4.66675)"
      fill="black"
    />
    <rect
      x="8.75"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 4.66675)"
      fill="black"
    />
    <rect
      x="7.5835"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 7.5835 4.66675)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 4.66675)"
      fill="black"
    />
    <rect
      x="5.25"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 5.25 4.66675)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="4.66675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 4.66675)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="5.83325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 5.83325)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 7)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="8.16675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 8.16675)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="9.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 9.33325)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 10.5)"
      fill="black"
    />
    <rect
      x="5.25"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 5.25 10.5)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 10.5)"
      fill="black"
    />
    <rect
      x="7.5835"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 7.5835 10.5)"
      fill="black"
    />
    <rect
      x="8.75"
      y="10.5"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 10.5)"
      fill="black"
    />
    <rect
      x="8.75"
      y="9.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 9.33325)"
      fill="black"
    />
    <rect
      x="8.75"
      y="8.16675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 8.16675)"
      fill="black"
    />
    <rect
      x="8.75"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 7)"
      fill="black"
    />
    <rect
      x="7.5835"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 7.5835 7)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="7"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 7)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="8.16675"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 8.16675)"
      fill="black"
    />
    <rect
      x="2.9165"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 2.9165 2.33325)"
      fill="black"
    />
    <rect
      x="4.0835"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 4.0835 2.33325)"
      fill="black"
    />
    <rect
      x="5.25"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 5.25 2.33325)"
      fill="black"
    />
    <rect
      x="6.4165"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 6.4165 2.33325)"
      fill="black"
    />
    <rect
      x="7.5835"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 7.5835 2.33325)"
      fill="black"
    />
    <rect
      x="8.75"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 8.75 2.33325)"
      fill="black"
    />
    <rect
      x="9.9165"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 9.9165 2.33325)"
      fill="black"
    />
    <rect
      x="11.0835"
      y="2.33325"
      width="1.16667"
      height="1.16667"
      transform="rotate(-90 11.0835 2.33325)"
      fill="black"
    />
  </svg>
);

export const PencilIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="6" y="13.9467" width="2" height="2" fill="#939393" />
    <rect x="6" y="15.9467" width="2" height="2" fill="#939393" />
    <rect x="4" y="17.9467" width="2" height="2" fill="#939393" />
    <rect x="2" y="17.9467" width="2" height="2" fill="#939393" />
    <rect x="6" y="17.9467" width="2" height="2" fill="#939393" />
    <rect x="8" y="17.9467" width="2" height="2" fill="#939393" />
    <rect x="10" y="17.9467" width="2" height="2" fill="#939393" />
    <rect x="8" y="11.8933" width="2" height="2" fill="#939393" />
    <rect x="10" y="13.8933" width="2" height="2" fill="#939393" />
    <rect x="10" y="9.94666" width="2" height="2" fill="#939393" />
    <rect x="12" y="7.94666" width="2" height="2" fill="#939393" />
    <rect x="14" y="5.94666" width="2" height="2" fill="#939393" />
    <rect x="16" y="3.94666" width="2" height="2" fill="#939393" />
    <rect x="12" y="15.8933" width="2" height="2" fill="#939393" />
    <rect x="14" y="13.9467" width="2" height="2" fill="#939393" />
    <rect x="16" y="11.9467" width="2" height="2" fill="#939393" />
    <rect x="18" y="9.94666" width="2" height="2" fill="#939393" />
    <rect x="20" y="7.94666" width="2" height="2" fill="#939393" />
    <rect x="18" y="3.94666" width="2" height="2" fill="#939393" />
    <rect x="18" y="5.94666" width="2" height="2" fill="#939393" />
    <rect x="20" y="5.94666" width="2" height="2" fill="#939393" />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 10 11)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 10 7)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 8 5)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 12 9)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 14 11)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 12 13)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 10 15)"
      fill="white"
    />
    <rect
      width="2"
      height="2"
      transform="matrix(3.93403e-07 1 1 -3.93402e-07 8 17)"
      fill="white"
    />
  </svg>
);

export const SkullIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <rect
      x="4.66675"
      y="2.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 4.66675 2.33334)"
      fill="#FF0000"
    />
    <rect
      x="2.33325"
      y="4.66666"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 2.33325 4.66666)"
      fill="#FF0000"
    />
    <rect
      y="7"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 0 7)"
      fill="#FF0000"
    />
    <rect
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 0 9.33334)"
      fill="#FF0000"
    />
    <rect
      y="11.6667"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 0 11.6667)"
      fill="#FF0000"
    />
    <rect
      y="14"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 0 14)"
      fill="#FF0000"
    />
    <rect
      x="18.6667"
      y="14"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 18.6667 14)"
      fill="#FF0000"
    />
    <rect
      x="2.33325"
      y="16.3333"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 2.33325 16.3333)"
      fill="#FF0000"
    />
    <rect
      x="4.66675"
      y="18.6667"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 4.66675 18.6667)"
      fill="#FF0000"
    />
    <rect
      x="4.66675"
      y="21"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 4.66675 21)"
      fill="#FF0000"
    />
    <rect
      x="14"
      y="21"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 14 21)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="21"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 7 21)"
      fill="#FF0000"
    />
    <rect
      x="11.6667"
      y="21"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 11.6667 21)"
      fill="#FF0000"
    />
    <rect
      x="9.33325"
      y="21"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 9.33325 21)"
      fill="#FF0000"
    />
    <rect
      x="9.33325"
      y="18.6667"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 9.33325 18.6667)"
      fill="#FF0000"
    />
    <rect
      x="9.33325"
      y="14"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 9.33325 14)"
      fill="#FF0000"
    />
    <rect
      x="4.66675"
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 4.66675 9.33334)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 7 9.33334)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="7"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 7 7)"
      fill="#FF0000"
    />
    <rect
      x="11.6667"
      y="7"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 11.6667 7)"
      fill="#FF0000"
    />
    <rect
      x="11.6667"
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 11.6667 9.33334)"
      fill="#FF0000"
    />
    <rect
      x="14"
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 14 9.33334)"
      fill="#FF0000"
    />
    <rect
      x="7"
      y="2.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 7 2.33334)"
      fill="#FF0000"
    />
    <rect
      x="9.33325"
      y="2.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 9.33325 2.33334)"
      fill="#FF0000"
    />
    <rect
      x="11.6667"
      y="2.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 11.6667 2.33334)"
      fill="#FF0000"
    />
    <rect
      x="14"
      y="2.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 14 2.33334)"
      fill="#FF0000"
    />
    <rect
      x="16.3333"
      y="4.66666"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 16.3333 4.66666)"
      fill="#FF0000"
    />
    <rect
      x="18.6667"
      y="7"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 18.6667 7)"
      fill="#FF0000"
    />
    <rect
      x="18.6667"
      y="9.33334"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 18.6667 9.33334)"
      fill="#FF0000"
    />
    <rect
      x="18.6667"
      y="11.6667"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 18.6667 11.6667)"
      fill="#FF0000"
    />
    <rect
      x="16.3333"
      y="16.3333"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 16.3333 16.3333)"
      fill="#FF0000"
    />
    <rect
      x="14"
      y="18.6667"
      width="2.33333"
      height="2.33333"
      transform="rotate(-90 14 18.6667)"
      fill="#FF0000"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="9" y="10.9467" width="2" height="2" fill="white" />
    <rect x="7" y="10.9467" width="2" height="2" fill="white" />
    <rect x="5" y="10.9467" width="2" height="2" fill="white" />
    <rect
      x="17"
      y="12.9467"
      width="2"
      height="2"
      transform="rotate(-180 17 12.9467)"
      fill="white"
    />
    <rect
      x="19"
      y="12.9467"
      width="2"
      height="2"
      transform="rotate(-180 19 12.9467)"
      fill="white"
    />
    <rect
      x="15"
      y="12.9467"
      width="2"
      height="2"
      transform="rotate(-180 15 12.9467)"
      fill="white"
    />
    <rect
      x="13"
      y="6.94666"
      width="2"
      height="2"
      transform="rotate(-180 13 6.94666)"
      fill="white"
    />
    <rect
      x="13"
      y="8.94666"
      width="2"
      height="2"
      transform="rotate(-180 13 8.94666)"
      fill="white"
    />
    <rect
      x="13"
      y="10.9467"
      width="2"
      height="2"
      transform="rotate(-180 13 10.9467)"
      fill="white"
    />
    <rect x="11" y="10.9467" width="2" height="2" fill="white" />
    <rect x="11" y="12.9467" width="2" height="2" fill="white" />
    <rect x="11" y="14.9467" width="2" height="2" fill="white" />
    <rect x="11" y="16.9467" width="2" height="2" fill="white" />
  </svg>
);
export const PictureIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="4" y="19" width="2" height="2" fill="white" />
    <rect x="6" y="19" width="2" height="2" fill="white" />
    <rect x="10" y="15" width="2" height="2" fill="white" />
    <rect x="8" y="17" width="2" height="2" fill="white" />
    <rect x="6" y="15" width="2" height="2" fill="white" />
    <rect x="4" y="13" width="2" height="2" fill="white" />
    <rect x="12" y="13" width="2" height="2" fill="white" />
    <rect x="14" y="11" width="2" height="2" fill="white" />
    <rect x="16" y="13" width="2" height="2" fill="white" />
    <rect x="18" y="11" width="2" height="2" fill="white" />
    <rect x="8" y="19" width="2" height="2" fill="white" />
    <rect x="2" y="11" width="2" height="2" fill="white" />
    <rect x="2" y="13" width="2" height="2" fill="white" />
    <rect x="2" y="15" width="2" height="2" fill="white" />
    <rect x="2" y="17" width="2" height="2" fill="white" />
    <rect x="18" y="19" width="2" height="2" fill="white" />
    <rect x="16" y="19" width="2" height="2" fill="white" />
    <rect x="12" y="19" width="2" height="2" fill="white" />
    <rect x="14" y="19" width="2" height="2" fill="white" />
    <rect x="10" y="19" width="2" height="2" fill="white" />
    <rect x="10" y="9" width="2" height="2" fill="white" />
    <rect x="8" y="7" width="2" height="2" fill="white" />
    <rect x="6" y="9" width="2" height="2" fill="white" />
    <rect x="8" y="11" width="2" height="2" fill="white" />
    <rect x="20" y="9" width="2" height="2" fill="white" />
    <rect x="20" y="7" width="2" height="2" fill="white" />
    <rect x="20" y="5" width="2" height="2" fill="white" />
    <rect x="18" y="3" width="2" height="2" fill="white" />
    <rect x="16" y="3" width="2" height="2" fill="white" />
    <rect x="14" y="3" width="2" height="2" fill="white" />
    <rect x="12" y="3" width="2" height="2" fill="white" />
    <rect x="10" y="3" width="2" height="2" fill="white" />
    <rect x="8" y="3" width="2" height="2" fill="white" />
    <rect x="6" y="3" width="2" height="2" fill="white" />
    <rect x="4" y="3" width="2" height="2" fill="white" />
    <rect x="2" y="5" width="2" height="2" fill="white" />
    <rect x="2" y="7" width="2" height="2" fill="white" />
    <rect x="2" y="9" width="2" height="2" fill="white" />
    <rect x="20" y="11" width="2" height="2" fill="white" />
    <rect x="20" y="13" width="2" height="2" fill="white" />
    <rect x="20" y="15" width="2" height="2" fill="white" />
    <rect x="20" y="17" width="2" height="2" fill="white" />
  </svg>
);
export const RevertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_12309_65189)">
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 14 11.3333)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 2 10)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 2 8.66669)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 2 7.33331)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 3.33325 6)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 11.3333 14)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 12.6667 14)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 12.6667 12.6667)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 10 15.3333)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 8.66675 15.3333)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 12.6667 7.33331)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 12.6667 6)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 11.3333 6)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 10 6)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 14 8.66669)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 14 10)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 3.33325 11.3333)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 3.33325 12.6667)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 4.66675 12.6667)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(8.74228e-08 1 1 -4.37114e-08 6 14)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 8.66675 7.33331)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 10 8.66669)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 7.33325 6)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 8.66675 4.66669)"
        fill="white"
      />
      <rect
        width="1.33333"
        height="1.33333"
        transform="matrix(0 -1 -1 -4.37114e-08 10 3.33331)"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12309_65189">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(16) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CreationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <rect
      x="13.2429"
      y="16.5"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="13.2429"
      y="3.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect x="15.0762" y="5.5" width="1.83333" height="1.83333" fill="#505152" />
    <rect x="4.99292" y="5.5" width="1.83333" height="1.83333" fill="#505152" />
    <rect
      x="15.0762"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="4.99292"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="15.0762"
      y="9.1665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="4.99292"
      y="9.1665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect x="15.0762" y="11" width="1.83333" height="1.83333" fill="#505152" />
    <rect x="4.99292" y="11" width="1.83333" height="1.83333" fill="#505152" />
    <rect
      x="15.0762"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="15.0762"
      y="14.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="4.99292"
      y="14.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="4.99292"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="11.4097"
      y="16.5"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="11.4097"
      y="3.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="9.57617"
      y="16.5"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="9.57617"
      y="3.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="7.74292"
      y="16.5"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="6.82617"
      y="16.5"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="7.74292"
      y="3.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
    <rect
      x="6.82617"
      y="3.6665"
      width="1.83333"
      height="1.83333"
      fill="#505152"
    />
  </svg>
);
export const GeneratorsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <rect
      x="13.75"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 12.375)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 12.375)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 12.7844)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 12.7844)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 12.375)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 12.7844)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 12.375)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 12.7844)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 12.375)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 12.7844)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 16.4509)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 16.4509)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 16.4509)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 16.4509)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 16.4509)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 14.6177)"
      fill="#505152"
    />
    <rect
      x="13.75"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 13.75 14.6177)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 14.6177)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 14.6177)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 14.6177)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 18.2844)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 18.2844)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 18.2844)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 18.2844)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 18.2844)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="18.2844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 18.2844)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 12.375)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="12.375"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 12.375)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 12.7844)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="12.7844"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 12.7844)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 16.4509)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="16.4509"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 16.4509)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 14.6177)"
      fill="#505152"
    />
    <rect
      x="20.1667"
      y="14.6177"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 20.1667 14.6177)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 10.5415)"
      fill="#505152"
    />
    <rect
      x="15.5835"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 15.5835 10.5415)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 10.5415)"
      fill="#505152"
    />
    <rect
      x="17.4167"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 17.4167 10.5415)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 10.5415)"
      fill="#505152"
    />
    <rect
      x="18.3335"
      y="10.5415"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.3335 10.5415)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 5.5)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 5.5)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="18.3333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 18.3333)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="18.3333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 18.3333)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 16.5)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 16.5)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 16.5)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 14.6667)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 14.6667)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 14.6667)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 12.8333)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 12.8333)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 12.8333)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 11)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 11)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 11)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 9.16675)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 9.16675)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 9.16675)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 7.33325)"
      fill="#505152"
    />
    <rect
      x="8.70825"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 8.70825 7.33325)"
      fill="#505152"
    />
    <rect
      x="10.5417"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 10.5417 7.33325)"
      fill="#505152"
    />
    <rect
      x="12.375"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 12.375 5.5)"
      fill="#505152"
    />
    <rect
      x="12.375"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 12.375 5.5)"
      fill="#505152"
    />
    <rect
      x="12.375"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 12.375 7.28467)"
      fill="#505152"
    />
    <rect
      x="12.375"
      y="9.11792"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 12.375 9.11792)"
      fill="#505152"
    />
    <rect
      x="14.2083"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 14.2083 5.5)"
      fill="#505152"
    />
    <rect
      x="14.2083"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 14.2083 5.5)"
      fill="#505152"
    />
    <rect
      x="14.2083"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 14.2083 7.28467)"
      fill="#505152"
    />
    <rect
      x="16.0417"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.0417 5.5)"
      fill="#505152"
    />
    <rect
      x="16.0417"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.0417 5.5)"
      fill="#505152"
    />
    <rect
      x="16.0417"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.0417 7.28467)"
      fill="#505152"
    />
    <rect
      x="16.9583"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.9583 5.5)"
      fill="#505152"
    />
    <rect
      x="16.9583"
      y="5.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.9583 5.5)"
      fill="#505152"
    />
    <rect
      x="16.9583"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 16.9583 7.28467)"
      fill="#505152"
    />
    <rect
      x="18.7917"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.7917 7.28467)"
      fill="#505152"
    />
    <rect
      x="18.7917"
      y="7.28467"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 18.7917 7.28467)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 9.16675)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 9.16675)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 12.8333)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 12.8333)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="12.8333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 12.8333)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 11)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 11)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="11"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 11)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 14.6667)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 14.6667)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="14.6667"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 14.6667)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 16.5)"
      fill="#505152"
    />
    <rect
      x="3.66675"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 3.66675 16.5)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="16.5"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 16.5)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="18.3333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 18.3333)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="18.3333"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 18.3333)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 7.33325)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="7.33325"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 7.33325)"
      fill="#505152"
    />
    <rect
      x="5.5"
      y="9.16675"
      width="1.83333"
      height="1.83333"
      transform="rotate(-180 5.5 9.16675)"
      fill="#505152"
    />
  </svg>
);
export const OpenExternalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect
      x="15"
      y="5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 15 5)"
      fill="white"
    />
    <rect
      x="15"
      y="6.66675"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 15 6.66675)"
      fill="white"
    />
    <rect
      x="15"
      y="8.33325"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 15 8.33325)"
      fill="white"
    />
    <rect
      x="15"
      y="10"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 15 10)"
      fill="white"
    />
    <rect
      x="13.3333"
      y="5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 13.3333 5)"
      fill="white"
    />
    <rect
      x="12.5"
      y="7.5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 12.5 7.5)"
      fill="white"
    />
    <rect
      x="10.8333"
      y="9.16675"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 10.8333 9.16675)"
      fill="white"
    />
    <rect
      x="6.66667"
      y="6.66675"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 6.66667 6.66675)"
      fill="white"
    />
    <rect
      x="5"
      y="6.66675"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 5 6.66675)"
      fill="white"
    />
    <rect
      x="3.33333"
      y="8.33325"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 3.33333 8.33325)"
      fill="white"
    />
    <rect
      x="3.33333"
      y="10"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 3.33333 10)"
      fill="white"
    />
    <rect
      x="3.33334"
      y="11.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 3.33334 11.6667)"
      fill="white"
    />
    <rect
      x="3.33334"
      y="13.3333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 3.33334 13.3333)"
      fill="white"
    />
    <rect
      x="3.33334"
      y="15"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 3.33334 15)"
      fill="white"
    />
    <rect
      x="5"
      y="16.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 5 16.6667)"
      fill="white"
    />
    <rect
      x="6.66667"
      y="16.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 6.66667 16.6667)"
      fill="white"
    />
    <rect
      x="8.33334"
      y="16.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 8.33334 16.6667)"
      fill="white"
    />
    <rect
      x="10"
      y="16.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 10 16.6667)"
      fill="white"
    />
    <rect
      x="11.6667"
      y="16.6667"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 11.6667 16.6667)"
      fill="white"
    />
    <rect
      x="13.3333"
      y="15"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 13.3333 15)"
      fill="white"
    />
    <rect
      x="13.3333"
      y="13.3333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 13.3333 13.3333)"
      fill="white"
    />
    <rect
      x="9.16667"
      y="10.8333"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 9.16667 10.8333)"
      fill="white"
    />
    <rect
      x="11.6667"
      y="5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 11.6667 5)"
      fill="white"
    />
    <rect
      x="10"
      y="5"
      width="1.66667"
      height="1.66667"
      transform="rotate(-90 10 5)"
      fill="white"
    />
  </svg>
);
